import type { BadgeProps } from '@paypoteam/ui-components';

import type { PrismicBadgeColorTypes } from '@/types';

export const mapBadgeColor = (
    badgeColor: PrismicBadgeColorTypes,
): BadgeProps['variant'] => {
    switch (badgeColor) {
        case 'green500':
        case 'green600':
            return 'green';
        case 'yellow400':
            return 'yellow';
        case 'red300':
        case 'red500':
            return 'red';
        case 'fuchsia200':
        case 'fuchsia500':
            return 'purple';
        case 'black':
            return 'black';
        default:
            return null;
    }
};
